/**
 * Shows inline "Please select a size" when ATC / sticky / Shop Pay / Buy now
 * is invoked while the Select-a-Size placeholder is still present.
 */
(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function show(section) {
    var msg = qs(section, '[data-size-required-msg]');
    if (!msg) return;
    msg.removeAttribute('hidden');
    msg.hidden = false;
    msg.setAttribute('aria-hidden', 'false');
    void msg.offsetHeight;
  }

  function hide(section) {
    var msg = qs(section, '[data-size-required-msg]');
    if (!msg) return;
    msg.setAttribute('hidden', '');
    msg.hidden = true;
    msg.setAttribute('aria-hidden', 'true');
  }

  function needsSize(section) {
    return !!qs(section, '.add-to-cart.onload-select--size');
  }

  function sizeSelectionStillRequired(section) {
    if (!section) {
      return false;
    }
    if (needsSize(section)) {
      return true;
    }
    return !!qs(section, '.variant-wrapper.no-selected-size');
  }

  function shakePlaceholder(section) {
    var ph = qs(section, '.add-to-cart.onload-select--size');
    if (!ph) return;
    ph.classList.add('clicked');
    window.setTimeout(function () {
      ph.classList.remove('clicked');
    }, 1000);
  }

  function getScrollTop() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  /**
   * Stops inertial / momentum scroll (e.g. iOS) by snapping the window to the current
   * scroll position so the next getBoundingClientRect() + scrollTo are not racing motion.
   */
  function stabilizeDocumentScroll() {
    var y = getScrollTop();
    var x = window.pageXOffset || (document.documentElement && document.documentElement.scrollLeft) || 0;
    try {
      if (window.scrollTo) {
        window.scrollTo({ top: y, left: x, behavior: 'auto' });
      } else {
        window.scrollTo(x, y);
      }
    } catch (e) {
      try {
        window.scrollTo(0, y);
      } catch (e2) {}
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = y;
    }
    if (document.body) {
      document.body.scrollTop = y;
    }
  }

  window.taosStabilizeDocumentScroll = stabilizeDocumentScroll;

  function setScrollTop(y) {
    y = Math.max(0, y);
    window.scrollTo(0, y);
    if (Math.abs(getScrollTop() - y) > 2) {
      document.documentElement.scrollTop = y;
      document.body.scrollTop = y;
    }
  }

  function getMaxScrollTop() {
    var se = document.documentElement;
    var b = document.body;
    var sh = Math.max(se.scrollHeight, b ? b.scrollHeight : 0, se.offsetHeight, b ? b.offsetHeight : 0);
    return Math.max(0, sh - window.innerHeight);
  }

  function viewportHeight() {
    return window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;
  }

  /**
   * Space to reserve below the sticky site header / announcement bar so scrolled content
   * is not tucked under fixed chrome (matches measured layout, not a fixed px guess).
   */
  function getTopFixedChromePx() {
    var gap = 16;
    var maxBottom = 0;
    var selectors = ['.toolbar', '.announcement-bar', '.site-header'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el || el.closest('#MobileNav') || el.closest('.mobile-nav')) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 4) continue;
      if (r.top > window.innerHeight * 0.4) continue;
      maxBottom = Math.max(maxBottom, r.bottom);
    }
    if (maxBottom < 48) {
      var fallback = document.querySelector('.site-header');
      if (fallback) maxBottom = Math.max(maxBottom, fallback.offsetHeight || 72);
      else maxBottom = 72;
    }
    try {
      var vv = window.visualViewport;
      if (vv && vv.offsetTop > 2) gap += vv.offsetTop;
    } catch (e) {}
    return Math.ceil(maxBottom + gap);
  }

  /** Union of viewport rects for nodes with non-zero layout (msg + size row). */
  function unionViewportRect(nodes) {
    var top = Infinity;
    var bottom = -Infinity;
    var any = false;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n) continue;
      var r = n.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      any = true;
      top = Math.min(top, r.top);
      bottom = Math.max(bottom, r.bottom);
    }
    if (!any || !isFinite(top)) return null;
    return { top: top, bottom: bottom };
  }

  /**
   * Scroll the window so the validation banner + size block fit between the header margin
   * and the sticky ATC bar. Uses document-space math (fixes “at bottom of page” jumps).
   */
  function scrollSizesIntoView(section) {
    stabilizeDocumentScroll();
    function applyScrollToVisibleBlock() {
      var msg = qs(section, '[data-size-required-msg]');
      var sizeWrap =
        qs(section, '.variant-input-wrap[name="Size"]') ||
        qs(section, '.variant-input-wrap[data-handle="size"]');

      var nodes = [];
      if (msg && !msg.hidden) nodes.push(msg);
      if (sizeWrap) nodes.push(sizeWrap);

      var unionRect = unionViewportRect(nodes);
      if (!unionRect && sizeWrap) unionRect = unionViewportRect([sizeWrap]);
      if (!unionRect && msg && !msg.hidden) unionRect = unionViewportRect([msg]);
      if (!unionRect) {
        var fb =
          qs(section, '.variant-wrapper.no-selected-size') ||
          qs(section, '.variant-wrapper.size-chart_flex');
        if (fb) unionRect = unionViewportRect([fb]);
      }
      if (!unionRect) return;

      var y0 = getScrollTop();
      var BB_doc = unionRect.bottom + y0;

      /** Align this document Y to sit just under fixed header (reference PDP). */
      var BT_anchor_doc;
      if (msg && !msg.hidden) {
        BT_anchor_doc = msg.getBoundingClientRect().top + y0;
      } else {
        BT_anchor_doc = unionRect.top + y0;
      }

      var stickyRaw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-product-atc-h').trim();
      var stickyPx = parseFloat(stickyRaw);
      if (isNaN(stickyPx)) stickyPx = 0;

      var bottomPad = 16;
      var vh = viewportHeight();
      var innerBottom = vh - stickyPx - bottomPad;

      var topReserve = getTopFixedChromePx();

      var Y_alignBanner = BT_anchor_doc - topReserve;
      var Y_fitSizesAboveSticky = BB_doc - innerBottom;

      var target = Y_alignBanner;

      if (Y_fitSizesAboveSticky > Y_alignBanner) {
        var bannerTopIfFitBottom = BT_anchor_doc - Y_fitSizesAboveSticky;
        if (bannerTopIfFitBottom >= topReserve - 2) {
          target = Y_fitSizesAboveSticky;
        }
      }

      target = Math.max(0, Math.min(getMaxScrollTop(), target));
      setScrollTop(target);
    }

    setTimeout(applyScrollToVisibleBlock, 0);
    setTimeout(applyScrollToVisibleBlock, 20);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        applyScrollToVisibleBlock();
        window.setTimeout(applyScrollToVisibleBlock, 50);
        window.setTimeout(applyScrollToVisibleBlock, 200);
        window.setTimeout(applyScrollToVisibleBlock, 450);
      });
    });
  }

  window.taosScrollSizesIntoView = scrollSizesIntoView;

  function isLayoutVisibleEl(el) {
    if (!el) {
      return false;
    }
    var st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') {
      return false;
    }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /**
   * Swatch “image” target: prefer the last option in the New Colors row, then the main
   * (not-on-sale) strip, then Sale Colors — matches “scroll to the last color swatch”.
   */
  function getLastColorSwatchTarget(section) {
    var colorWrap =
      qs(section, '.variant-input-wrap[name="Color"]') ||
      qs(section, '.variant-input-wrap[data-handle="color"]');
    if (!colorWrap) {
      return null;
    }

    function lastSwatchIn(container) {
      if (!container) {
        return null;
      }
      var list = container.querySelectorAll('.variant-input.color-swatch-variant');
      for (var i = list.length - 1; i >= 0; i--) {
        if (isLayoutVisibleEl(list[i])) {
          var lab = list[i].querySelector('label.color-swatch');
          return isLayoutVisibleEl(lab) ? lab : list[i];
        }
      }
      return null;
    }

    return (
      lastSwatchIn(colorWrap.querySelector('.new_color')) ||
      lastSwatchIn(colorWrap.querySelector('.not-on-sale-colors')) ||
      lastSwatchIn(colorWrap.querySelector('.on-sale-colors')) ||
      (function () {
        var all = colorWrap.querySelectorAll('.variant-input.color-swatch-variant');
        for (var j = all.length - 1; j >= 0; j--) {
          if (isLayoutVisibleEl(all[j])) {
            var l = all[j].querySelector('label.color-swatch');
            return isLayoutVisibleEl(l) ? l : all[j];
          }
        }
        return null;
      })()
    );
  }

  /**
   * Desktop sticky ATC: scroll focus on the last color swatch (or fall back to the top
   * of the variant block if the theme has no swatches).
   */
  function getDesktopOptionsScrollTarget(section) {
    var lastSw = getLastColorSwatchTarget(section);
    if (lastSw) {
      return lastSw;
    }
    var picker = qs(section, '.product-block--variant');
    if (picker) {
      var firstRow = picker.querySelector('.variant-wrapper');
      if (firstRow) {
        return firstRow;
      }
    }
    return (
      qs(section, '.variant-input-wrap[name="Color"]') ||
      qs(section, '.variant-input-wrap[data-handle="color"]') ||
      qs(section, '.variant-input-wrap[name="Size"]') ||
      qs(section, '.variant-input-wrap[data-handle="size"]') ||
      null
    );
  }

  /**
   * Desktop sticky ATC: show the size-required message, then scroll to the top of the
   * variant options column (same show() as the main form path).
   */
  function scrollToColorForSizeSelection(section) {
    if (!section) {
      return;
    }
    stabilizeDocumentScroll();
    if (sizeSelectionStillRequired(section)) {
      show(section);
    }
    var scrollTarget = getDesktopOptionsScrollTarget(section);
    if (!scrollTarget) {
      scrollSizesIntoView(section);
      return;
    }
    shakePlaceholder(section);
    function apply() {
      var y0 = getScrollTop();
      var nodes = [scrollTarget];
      var msg = qs(section, '[data-size-required-msg]');
      if (msg && !msg.hidden) {
        nodes.push(msg);
      }
      var sizeW =
        qs(section, '.variant-input-wrap[name="Size"]') ||
        qs(section, '.variant-input-wrap[data-handle="size"]');
      if (sizeW) {
        nodes.push(sizeW);
      }
      var topDoc = Infinity;
      var bottomDoc = -Infinity;
      var any = false;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (!node) {
          continue;
        }
        var br = node.getBoundingClientRect();
        if (br.width === 0 && br.height === 0) {
          continue;
        }
        any = true;
        topDoc = Math.min(topDoc, br.top + y0);
        bottomDoc = Math.max(bottomDoc, br.bottom + y0);
      }
      if (!any) {
        var r0 = scrollTarget.getBoundingClientRect();
        topDoc = r0.top + y0;
        bottomDoc = r0.bottom + y0;
      }
      var BT_doc = topDoc;
      var BB_doc = bottomDoc;
      var stickyRaw = getComputedStyle(document.documentElement)
        .getPropertyValue('--sticky-product-atc-h')
        .trim();
      var stickyPx = parseFloat(stickyRaw);
      if (isNaN(stickyPx)) stickyPx = 0;
      var bottomPad = 16;
      var vh = viewportHeight();
      var innerBottom = vh - stickyPx - bottomPad;
      var topReserve = getTopFixedChromePx();
      var Y_align = BT_doc - topReserve;
      var Y_fit = BB_doc - innerBottom;
      var target = Y_align;
      if (Y_fit > Y_align) {
        var topIfFit = BT_doc - Y_fit;
        if (topIfFit >= topReserve - 2) {
          target = Y_fit;
        }
      }
      target = Math.max(0, Math.min(getMaxScrollTop(), target));
      setScrollTop(target);
    }

    function focusLastSwatchInRow() {
      if (!scrollTarget || !scrollTarget.closest) {
        return;
      }
      var inColor = scrollTarget.closest(
        '.variant-input-wrap[name="Color"], .variant-input-wrap[data-handle="color"]'
      );
      if (!inColor) {
        return;
      }
      if (typeof scrollTarget.scrollIntoView !== 'function') {
        return;
      }
      try {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
      } catch (e) {
        scrollTarget.scrollIntoView(false);
      }
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        apply();
        window.setTimeout(apply, 50);
        window.setTimeout(apply, 200);
        window.setTimeout(apply, 450);
        window.setTimeout(focusLastSwatchInRow, 120);
        window.setTimeout(focusLastSwatchInRow, 400);
      });
    });
  }

  window.taosScrollToColorForSize = scrollToColorForSizeSelection;

  function showSizeRequiredAndScroll(section) {
    if (!section || !sizeSelectionStillRequired(section)) {
      return;
    }
    stabilizeDocumentScroll();
    show(section);
    shakePlaceholder(section);
    scrollSizesIntoView(section);
  }

  window.taosShowSizeRequiredAndScroll = showSizeRequiredAndScroll;

  function scrollToSizes(section) {
    scrollSizesIntoView(section);
  }

  function bindSection(section) {
    if (!qs(section, '[data-size-required-msg]')) return;

    function hideIfSizeResolved() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (!sizeSelectionStillRequired(section)) {
            hide(section);
          }
        });
      });
    }

    section.addEventListener('variantChange', hideIfSizeResolved);

    section.addEventListener(
      'change',
      function (e) {
        var wrap = e.target.closest('.variant-input-wrap[name="Size"]');
        if (!wrap || !section.contains(wrap)) return;
        hideIfSizeResolved();
      },
      true
    );

    /*
      Re-clicking the already-selected size does not fire change; theme still removes the
      placeholder / no-selected-size. Hide the banner once size selection is no longer required.
    */
    section.addEventListener(
      'click',
      function (e) {
        var wrap = e.target.closest('.variant-input-wrap[name="Size"]');
        if (!wrap || !section.contains(wrap)) return;
        if (
          !e.target.closest(
            'input[data-variant-input][name="Size"], input[type="radio"][name="Size"], .variant__button-label, .size-view-btn, .wide-view-btn'
          )
        ) {
          return;
        }
        hideIfSizeResolved();
      },
      false
    );
  }

  function onPlaceholderClick(e) {
    var ph = e.target.closest('.add-to-cart.onload-select--size');
    if (!ph) return;
    var section = ph.closest('.product-section');
    if (!section || !needsSize(section)) return;
    e.preventDefault();
    e.stopPropagation();
    show(section);
    shakePlaceholder(section);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToSizes(section);
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-section').forEach(bindSection);

    document.addEventListener('click', onPlaceholderClick);

    document.addEventListener('click', function (evt) {
      var bn = evt.target.closest('.buy-now-button.size_not-selected');
      if (!bn) return;
      var section = bn.closest('.product-section');
      if (!section || !needsSize(section)) return;
      evt.preventDefault();
      show(section);
      shakePlaceholder(section);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollToSizes(section);
        });
      });
    });

    document.addEventListener('click', function (evt) {
      var shopPayBtn = evt.target.closest('.onload-select--size ~ .shopify-payment-button');
      if (!shopPayBtn) return;
      var section = shopPayBtn.closest('.product-section');
      if (!section || !needsSize(section)) return;
      evt.preventDefault();
      show(section);
      shakePlaceholder(section);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollToSizes(section);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
